/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-12-02 14:09:48
 * @Description: 
 */
import React from "react"
import { CanvasLoadingLarger } from "src/assets";
import urls from "src/constant/url";
import FTCanvasStore from "src/store/FTCanvasStore";
import FTImageStore from "src/store/FTImageStore";
import FTLang from "src/utils/FTLang"
import "./FTEffectLoading.scss"

interface IState {
  quotes: string
}
class FTEffectLoading extends React.Component<{}, IState> {
  componentDidMount() {
    this.changeQuotes()
    this.timer = setInterval(() => {
      this.changeQuotes()
    }, 3000);
  }

  timer:any =  null

  componentWillUnmount() {
    clearInterval(this.timer)
    this.timer = null
  }

  state: IState = {
    quotes: ""
  }

  changeQuotes() {
    let index = Math.ceil(Math.random() * 23)
    let quotes: string = "goart_quotes"
    if(index < 10)
      quotes = quotes + "0" + index
    else 
      quotes = quotes + index
    this.setState({
      quotes
    })
  }

  render() {
    let { quotes } = this.state
    let { isMobile } = FTCanvasStore
    let { unlockData } = FTImageStore.currentEffect
    return <div className={`effect_loading ${isMobile ? "effect_loading_mobile" : ""}`}>
      <div className="effect_loading_header">
        <span>{FTLang._("goart_drawering", {
          name: FTImageStore.currentEffect.name + " "
        })}</span>
        <img src={CanvasLoadingLarger} alt="" />
      </div>
      {unlockData && unlockData.posterImage && <div className="effect_loading_img">
        <img src={urls.assetsUrl + unlockData.posterImage} alt=""/>
      </div>}
      <div className="effect_loading_person" dangerouslySetInnerHTML={{
        __html: FTLang._(quotes)
      }}>
      </div>
    </div>
  }
}

export default FTEffectLoading